import UserTypeSelectorContainer from "./UserTypeSelectorContainer.vue";
export default UserTypeSelectorContainer;